import React from 'react';
import {getDisplayLinkName} from "../Utils.ts";
import {handleLinkClick} from "../../../../../Utils/misc/openLink.ts";
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";

interface LinkProps {
    item: {
        fileContent: string;
        fileName: string;
        previewUrl: string;
    };
    index: number;
    role: string | null;
}

const Link: React.FC<LinkProps> = ({ item, index, role }) => {
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const url = item.fileName.startsWith('https://') ? item.fileName : `https://${item.fileName}`;
    const displayLinkName = getDisplayLinkName(item.fileName)

    const handleFileClick = (fileContents: string) => {
        setDynamicStateObj({
            visiblePopup: "enlargedContent",
            enlargedContent: {type: "file", content: fileContents},
        });
    };

    return (
        <div className="flex-none">
            <div className={`my-3 mx-0.5 flex flex-col pt-1 pb-0 bg-neutral-200 dark:bg-neutral-900 items-center w-28 h-22 border border-neutral-800 rounded-lg`}>
                {role === "assistant" && (
                    <div className={"text-xs pb-1"}>
                        {index+1}
                    </div>
                )}
                <button
                    className="mb-0.5 p-1 w-12 h-12 object-contain cursor-pointer"
                    onClick={() => {
                        handleFileClick(item.fileContent);
                    }}
                >
                    <img
                        className={"h-10 w-10"}
                        src={item.previewUrl}
                        alt="Message Link"
                    />
                </button>
                <div
                    className="mb-1.5 text-xs cursor-pointer"
                    onClick={(e) => {
                        handleLinkClick(e, environment, vscode, url);
                    }}
                    data-tooltip-id="main-tooltip"
                    data-tooltip-content={item.fileName}
                    data-tooltip-place="top"
                >
                    {displayLinkName}
                </div>
            </div>
        </div>
    );
};

export default Link;